import { useState } from 'react';
import { featuredArtworks } from '../../../mocks/artworks';

export default function ShopSection() {
  const [selectedArtwork, setSelectedArtwork] = useState<typeof featuredArtworks[0] | null>(null);

  const handlePrevious = () => {
    if (!selectedArtwork) return;
    const currentIndex = featuredArtworks.findIndex(art => art.id === selectedArtwork.id);
    const previousIndex = currentIndex > 0 ? currentIndex - 1 : featuredArtworks.length - 1;
    setSelectedArtwork(featuredArtworks[previousIndex]);
  };

  const handleNext = () => {
    if (!selectedArtwork) return;
    const currentIndex = featuredArtworks.findIndex(art => art.id === selectedArtwork.id);
    const nextIndex = currentIndex < featuredArtworks.length - 1 ? currentIndex + 1 : 0;
    setSelectedArtwork(featuredArtworks[nextIndex]);
  };

  return (
    <section id="shop" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-20">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 bg-[#e8a65b] rounded-full"></div>
            <span className="text-xs uppercase tracking-widest text-gray-600 font-medium">
              Tienda de Arte
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Adquiere Arte <span className="text-[#e8a65b]">Original</span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Cada pieza es única y viene con certificado de autenticidad
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-product-shop>
          {featuredArtworks.map((artwork) => (
            <div
              key={artwork.id}
              onClick={() => setSelectedArtwork(artwork)}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-2xl bg-gray-100 mb-4 shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="w-full h-80">
                  <img
                    src={artwork.image}
                    alt={artwork.title}
                    className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                {artwork.sold ? (
                  <div className="absolute top-4 right-4 bg-[#e8a65b] text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg">
                    VENDIDO
                  </div>
                ) : (
                  <div className="absolute top-4 right-4 bg-emerald-500 text-white px-4 py-2 rounded-full text-sm font-bold shadow-lg animate-pulse">
                    DISPONIBLE
                  </div>
                )}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{artwork.title}</h3>
              <p className="text-sm text-gray-500 mb-2">{artwork.technique}</p>
              <p className="text-sm text-gray-600 mb-3">{artwork.dimensions}</p>
              <p className="text-xl font-bold text-[#e8a65b]">{artwork.price}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/gallery"
            className="inline-block bg-[#e8a65b] text-white px-8 py-3 rounded-full font-medium hover:bg-[#d99549] transition-colors whitespace-nowrap cursor-pointer"
            onClick={(e) => {
              e.preventDefault();
              window.REACT_APP_NAVIGATE('/gallery');
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }, 100);
            }}
          >
            Ver Colección Completa
          </a>
        </div>
      </div>

      {/* Artwork Modal with Navigation */}
      {selectedArtwork && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedArtwork(null)}
        >
          <div 
            className="relative max-w-6xl w-full h-full flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={selectedArtwork.image}
              alt={selectedArtwork.title}
              className="max-w-full max-h-[85vh] object-contain"
            />
            <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 bg-black/80 backdrop-blur-sm px-6 py-4 rounded-full">
              <h3 className="text-xl font-serif text-white mb-1 text-center">{selectedArtwork.title}</h3>
              <p className="text-sm text-gray-300 text-center">{selectedArtwork.technique}</p>
              <p className="text-lg font-bold text-[#e8a65b] text-center mt-2">{selectedArtwork.price}</p>
            </div>
            
            {/* Previous Button */}
            <button
              onClick={handlePrevious}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 rounded-full text-gray-900 hover:bg-white transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-2xl"></i>
            </button>
            
            {/* Next Button */}
            <button
              onClick={handleNext}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 rounded-full text-gray-900 hover:bg-white transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-2xl"></i>
            </button>
            
            {/* Close Button */}
            <button
              onClick={() => setSelectedArtwork(null)}
              className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center bg-white rounded-full text-gray-900 hover:bg-gray-100 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-2xl"></i>
            </button>
          </div>
        </div>
      )}
    </section>
  );
}